module.exports = __webpack_public_path__ + "img/ico_info.16906543.svg";